const getCurrentHostname = () => (typeof window !== 'undefined' ? window.location.hostname : '');

export default getCurrentHostname;
